const noDoubleSlash = /([^:]\/)\/+/g;

export function safeUrl(url: string): string {
  return url.replace(noDoubleSlash, '$1');
}

export function getUrlParameter<T = string>(url: string, paramName: string): T | undefined {
  const urlObj = new URL(url);
  const paramValue = urlObj.searchParams.get(paramName);
  if (paramValue === null) {
    return undefined;
  }
  try {
    return JSON.parse(paramValue) as T;
  } catch {
    return paramValue as unknown as T;
  }
}

export function getCurrentUrlParameter<T = string>(paramName: string): T | undefined {
  const url = window.location.href;
  return getUrlParameter<T>(url, paramName);
}

export function normalizePath(path: string) {
  return path.replace(/\/+$/, '').toLowerCase();
}
